import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import getUserToken from '../../helpers/tokenValidation';

const backendURL = process.env.REACT_APP_API_URL;


export const fetchConversations = createAsyncThunk(
  'chat/fetchConversations',
  async (currentUserId, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const { data } = await axios.get(`${backendURL}/api/chat/user-conversations/${currentUserId}`, config);
      return data;
    }
    catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchEligibleChatUsers = createAsyncThunk(
  'chat/fetchEligibleChatUsers',
  async (currentUserId, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const { data } = await axios.get(`${backendURL}/api/eligible-chat-users/${currentUserId}`, config);
      return data;
    }
    catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getOrCreateConversation = createAsyncThunk(
  'chat/getOrCreateConversation',
  async ({ user1Id, user2Id }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`
        }
      };
      const { data } = await axios.post(
        `${backendURL}/api/conversation`,
        { user1: parseInt(user1Id, 10), user2: parseInt(user2Id, 10) },
        config
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addMessage = createAsyncThunk(
  'chat/addMessage',
  async ({ conversationId, message, receiverId, senderId }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`
        }
      };
      await axios.post(`${backendURL}/api/chat/messages`, {
        conversationId,
        message,
        receiverId,
        senderId
      }, config);
      console.log("Message sent to backend:", { conversationId, message, senderId });
      return { conversationId, message, senderId };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const clearChatError = createAsyncThunk(
  'chat/clearChatError',
  async (_, { dispatch }) => {
    dispatch({ type: 'chat/clearError' });
  }
);

export const fetchUnreadCount = createAsyncThunk(
  'chat/fetchUnreadCount',
  async (userId, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const { data } = await axios.get(`${backendURL}/api/chat/unread-count/${userId}`, config);
      return data.count;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const markAsRead = createAsyncThunk(
  'chat/markAsRead',
  async ({ conversationId, userId }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      await axios.post(`${backendURL}/api/chat/mark-read`, { conversationId, userId }, config);
      return conversationId;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

